import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { PlanBadge } from '../UI/Badge';
import BeeAppeeLogo from '../../assets/BeeAppeeLogo';
import ChatBubble from '../ChatBubble';
import GenieCoach from '../GenieCoach';
import './Layout.css';

// ── SVG Nav Icons ─────────────────────────────────────────────────────────────
function IconDashboard() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5"/>
    </svg>
  );
}
function IconBirthday() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-1a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1"/>
      <path d="M12 3c1.5 1.5 1.5 3 0 4"/>
      <path d="M4 11h16"/>
      <path d="M4 11v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/>
      <path d="M2 15c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>
    </svg>
  );
}
function IconContacts() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}
function IconCampaigns() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 2L11 13"/>
      <path d="M22 2L15 22l-4-9-9-4 20-7z"/>
    </svg>
  );
}
function IconStrategy() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <circle cx="12" cy="12" r="4"/>
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
      <line x1="2" y1="12" x2="8" y2="12"/>
      <line x1="16" y1="12" x2="22" y2="12"/>
    </svg>
  );
}
function IconAnalytics() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
      <line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  );
}
function IconTemplates() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
    </svg>
  );
}
function IconImport() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="8 17 12 21 16 17"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"/>
    </svg>
  );
}
function IconSettings() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  );
}
function IconGuide() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  );
}
function IconAdmin() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}
function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  );
}

// ── Gamification mini-widget ───────────────────────────────────────────────────
const LEVELS = [
  { min: 0,   max: 9,   name: 'Créateur de lien',    icon: '🌱', color: '#9CA3AF', grad: 'linear-gradient(90deg, #6B7280, #9CA3AF)' },
  { min: 10,  max: 49,  name: 'Relation active',      icon: '💙', color: '#3B82F6', grad: 'linear-gradient(90deg, #2563EB, #60A5FA)' },
  { min: 50,  max: 199, name: 'Good Energy Sender',   icon: '⚡', color: '#10B981', grad: 'linear-gradient(90deg, #059669, #34D399)' },
  { min: 200, max: 499, name: 'Ambassadeur client',   icon: '🚀', color: '#A78BFA', grad: 'linear-gradient(90deg, #7C3AED, #A78BFA)' },
  { min: 500, max: Infinity, name: 'Génie des relations', icon: '🌟', color: '#FCD34D', grad: 'linear-gradient(90deg, #D97706, #FCD34D)' },
];
const BADGES_COUNT = 8;
const BADGE_CHECKS = [
  (u) => (u?.emails_used ?? 0) >= 10,
  (u) => (u?.birthdays_sent ?? 0) >= 5,
  (u) => (u?.feedbacks_received ?? 0) >= 1,
  (u) => (u?.reactivations ?? 0) >= 1,
  (u) => (u?.contacts_used ?? 0) >= 10,
  (u) => (u?.campaigns_local ?? 0) >= 1,
  (u) => (u?.vip_contacted ?? 0) >= 1,
  (u) => (u?.emails_used ?? 0) >= 100,
];

function SidebarLevelWidget({ usage }) {
  const sent   = usage?.emails_used ?? 0;
  const level  = LEVELS.find(l => sent >= l.min && sent <= l.max) ?? LEVELS[0];
  const next   = LEVELS[LEVELS.indexOf(level) + 1];
  const pct    = next ? Math.min(Math.round(((sent - level.min) / (next.min - level.min)) * 100), 100) : 100;
  const toNext = next ? next.min - sent : 0;
  const earned = BADGE_CHECKS.filter(fn => fn(usage)).length;

  return (
    <div className="slw-wrap">
      <div className="slw-row">
        <span className="slw-icon">{level.icon}</span>
        <div className="slw-info">
          <div className="slw-name" style={{ color: level.color }}>{level.name}</div>
          {next
            ? <div className="slw-next">encore {toNext} msg → {next.icon}</div>
            : <div className="slw-next">Niveau max atteint 🏆</div>
          }
        </div>
        {earned > 0 && (
          <div className="slw-badge-count" title={`${earned} badges débloqués`}>
            🏅 {earned}
          </div>
        )}
      </div>
      <div className="slw-bar-track">
        <div className="slw-bar-fill" style={{ width: `${pct}%`, background: level.grad }} />
        {pct > 10 && (
          <div className="slw-bar-shine" style={{ left: `${Math.min(pct - 6, 88)}%` }} />
        )}
      </div>
      <div className="slw-pct">{pct}%</div>
    </div>
  );
}

// ── Nav items definition with SVG icons ───────────────────────────────────────
const IconMessages = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const navItems = [
  // Mode simple : l'essentiel. Anniversaires vit sur l'Accueil (badge conservé),
  // l'import s'ouvre depuis Contacts, Analytics simple = 3 chiffres sur l'Accueil.
  { to: '/dashboard',  icon: <IconDashboard />,  label: 'Accueil',   badgeKey: 'todayBdays' },
  { to: '/contacts',   icon: <IconContacts />,   label: 'Contacts',  badgeKey: null },
  { to: '/campaigns',  icon: <IconCampaigns />,  label: 'Campagnes', badgeKey: 'campaigns' },
  { to: '/messages',   icon: <IconMessages />,   label: 'Messages',  badgeKey: null },
  // « Le Guide » a migré en bas (près de Paramètres) — voir plus bas dans le rendu.
];

// Mode expert : les outils avancés (pages intactes, simplement révélées)
const EXPERT_NAV_ITEMS = [
  { to: '/strategy',   icon: <IconStrategy />,   label: 'Stratégie', badgeKey: 'strategy', expert: true },
  { to: '/studio',     icon: <IconTemplates />,  label: 'Studio',    badgeKey: null,       expert: true },
  { to: '/analytics',  icon: <IconAnalytics />,  label: 'Analytics', badgeKey: null,       expert: true },
];

// ── Animated nav item ─────────────────────────────────────────────────────────
function NavItemAnimated({ to, icon, label, badge, delay, onClick, expert = false }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `nav-item${isActive ? ' nav-item-active' : ''}`}
      onClick={onClick}
      style={{ animationDelay: `${delay}ms` }}
    >
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
      {expert && <span className="nav-expert-tag">EXPERT</span>}
      {badge > 0 && (
        <span className="nav-badge">{badge > 9 ? '9+' : badge}</span>
      )}
    </NavLink>
  );
}

// ── AI Disabled Banner ────────────────────────────────────────────────────────
function AiDisabledBanner() {
  const { aiEnabled } = useApp();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = React.useState(() => {
    try { return sessionStorage.getItem('ai_banner_dismissed') === '1'; } catch { return false; }
  });
  if (aiEnabled || dismissed) return null;
  return (
    <div style={{
      background: 'linear-gradient(90deg, #1E0A3C, #2D1465)',
      borderBottom: '1px solid rgba(90,53,255,.4)',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', gap: 12,
      fontSize: 13, zIndex: 100,
    }}>
      {/* Icône */}
      <div style={{
        width: 32, height: 32, borderRadius: 10, flexShrink: 0,
        background: 'rgba(90,53,255,.35)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
      }}>🤖</div>

      {/* Texte + pills */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, color: '#fff', marginBottom: 3 }}>
          Tes conseils IA sont désactivés
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {['Messages personnalisés', 'Insights sur ta base', 'Stratégie adaptée à ton secteur'].map(t => (
            <span key={t} style={{
              fontSize: 11, background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.15)',
              color: 'rgba(255,255,255,.6)', borderRadius: 6, padding: '1px 7px',
            }}>✗ {t}</span>
          ))}
        </div>
      </div>

      {/* CTA */}
      <button
        onClick={() => navigate('/settings?tab=plan')}
        style={{
          background: 'linear-gradient(135deg,#5A35FF,#8B5CF6)', color: '#fff',
          border: 'none', borderRadius: 9, padding: '8px 16px',
          fontWeight: 700, fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap',
          flexShrink: 0, boxShadow: '0 4px 14px rgba(90,53,255,.5)',
        }}
      >Reprendre l'IA →</button>

      {/* Fermer */}
      <button
        onClick={() => { setDismissed(true); try { sessionStorage.setItem('ai_banner_dismissed','1'); } catch {} }}
        style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.4)', cursor: 'pointer', fontSize: 16, flexShrink: 0, padding: '2px 4px' }}
      >✕</button>
    </div>
  );
}

// ── Layout ────────────────────────────────────────────────────────────────────
export default function Layout({ children }) {
  const { user, tenant, contacts, notifications, logout, dashboardData, autoSendEnabled, strategyInstances, campaigns, expertMode, toggleExpertMode } = useApp();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const contactsCount = contacts?.length ?? 0;
  const usagePercent  = Math.round((contactsCount / (tenant?.contacts_limit || 500)) * 100);
  const usageColor    = usagePercent > 85 ? 'linear-gradient(90deg,#EF4444,#F97316)' : 'linear-gradient(90deg,#6C5CE7,#9B8EFF)';

  // Badge count for birthdays
  const todayBdayCount = dashboardData?.today_birthdays?.length ?? dashboardData?.stats?.today_birthdays ?? 0;

  // Badge stratégie : nombre de stratégies en retard
  const behindStratCount = (strategyInstances || []).filter(s => {
    const phases = s.phases || [];
    const total  = phases.reduce((sum, p) => sum + (p.actions?.length || 0), 0);
    const done   = phases.reduce((sum, p) => sum + (p.actions?.filter(a => a.done).length || 0), 0);
    const pct    = total > 0 ? Math.round(done / total * 100) : 0;
    const launchedDays = Math.floor((Date.now() - new Date(s.launchedAt || Date.now()).getTime()) / 86400000);
    const totalDays    = (() => { const d = parseInt(s.duration || '') || 0; if ((s.duration||'').includes('12 mois')) return 365; if ((s.duration||'').includes('mois')) return d * 30; if ((s.duration||'').includes('semaine')) return d * 7; return 90; })();
    const expectedPct  = Math.min(100, Math.round((launchedDays / Math.max(totalDays, 1)) * 100));
    return pct < expectedPct - 12 && launchedDays > 3;
  }).length;

  // Badge campagnes : brouillons en attente d'envoi
  const draftCampaignCount = (campaigns || []).filter(c => c.status === 'draft').length;

  const badges = { todayBdays: todayBdayCount, strategy: behindStratCount, campaigns: draftCampaignCount };

  const firstName = user?.name?.split(' ')[0] ?? user?.name ?? '';

  return (
    <div className="layout">
      {/* Mobile overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}

      {/* ── Sidebar ── */}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>

        {/* Logo */}
        <div className="sidebar-logo">
          <div className="sidebar-brand">
            <BeeAppeeLogo width={140} />
          </div>
          <PlanBadge plan={tenant?.plan} />
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {navItems.map((item, i) => (
            <NavItemAnimated
              key={item.to}
              to={item.to}
              icon={item.icon}
              label={item.label}
              badge={item.badgeKey ? (badges[item.badgeKey] ?? 0) : 0}
              delay={i * 40}
              onClick={() => {
                setSidebarOpen(false);
                // Le badge « Accueil » = anniversaires du jour → clic = on défile jusqu'à leur section.
                if (item.badgeKey === 'todayBdays' && (badges.todayBdays ?? 0) > 0) {
                  const scroll = () => document.getElementById('section-today')
                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  if (window.location.pathname === '/dashboard') scroll();
                  else setTimeout(scroll, 400); // laisse la home se monter avant de défiler
                }
              }}
            />
          ))}

          {expertMode && EXPERT_NAV_ITEMS.map((item, i) => (
            <NavItemAnimated
              key={item.to}
              to={item.to}
              icon={item.icon}
              label={item.label}
              badge={item.badgeKey ? (badges[item.badgeKey] ?? 0) : 0}
              delay={(navItems.length + i) * 40}
              onClick={() => setSidebarOpen(false)}
              expert
            />
          ))}

          {user?.role === 'admin' && (
            <NavItemAnimated
              to="/admin"
              icon={<IconAdmin />}
              label="Admin"
              badge={0}
              delay={navItems.length * 40}
              onClick={() => setSidebarOpen(false)}
            />
          )}

          {/* Spacer before settings */}
          <div className="nav-sep" />

          {/* Le Guide — déplacé en bas (aide/ressources), icône en trait cohérente */}
          <NavItemAnimated
            to="/astuces"
            icon={<IconGuide />}
            label="Le Guide"
            badge={0}
            delay={(navItems.length) * 40}
            onClick={() => setSidebarOpen(false)}
          />

          <NavItemAnimated
            to="/settings?tab=entreprise"
            icon={<IconSettings />}
            label="Paramètres"
            badge={0}
            delay={(navItems.length + 1) * 40}
            onClick={() => setSidebarOpen(false)}
          />

          {/* Interrupteur mode simple/expert — mémorisé par utilisateur */}
          <button
            type="button"
            className={`nav-expert-toggle ${expertMode ? 'on' : ''}`}
            onClick={toggleExpertMode}
            title={expertMode ? 'Repasser en mode simple' : 'Débloquer les outils avancés'}
          >
            <span className="nav-icon">🎛️</span>
            <span className="net-txt">
              Mode expert
              <span className="net-hint">{expertMode ? 'Activé' : 'Outils avancés'}</span>
            </span>
            <span className="net-switch" />
          </button>
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">

          {/* Level widget */}
          {dashboardData?.usage && (
            <SidebarLevelWidget usage={dashboardData.usage} />
          )}

          {/* Contacts usage */}
          <div className="sidebar-usage">
            <div className="usage-bar-label">
              <span>Contacts</span>
              <span className="usage-count">{contactsCount} <span className="usage-limit">/ {tenant?.contacts_limit ?? 500}</span></span>
            </div>
            <div className="usage-bar-track">
              <div className="usage-bar-fill" style={{ width: `${Math.min(usagePercent, 100)}%`, background: usageColor }} />
              {usagePercent > 10 && usagePercent < 100 && (
                <div className="usage-bar-shine" style={{ left: `${Math.min(usagePercent - 8, 85)}%` }} />
              )}
            </div>
          </div>

          {/* User row */}
          <div className="sidebar-user-row">
            <NavLink to="/settings?tab=profile" className="sidebar-user" onClick={() => setSidebarOpen(false)}>
              <div className="sidebar-avatar">
                {(user?.name ?? user?.email ?? '?').charAt(0).toUpperCase()}
                <div className="sidebar-avatar-ring" />
              </div>
              <div className="sidebar-user-info">
                <div className="sidebar-user-name">{firstName}</div>
                <div className="sidebar-user-company">{user.company || 'Mon entreprise'}</div>
              </div>
            </NavLink>
            <button className="sidebar-logout-icon" onClick={handleLogout} title="Se déconnecter">
              <LogoutIcon />
            </button>
          </div>

        </div>
      </aside>

      {/* ── Main content ── */}
      <main className="main">
        {/* Bannière globale : envois en pause (visible sur toutes les pages) */}
        {tenant?.settings?.sending_paused && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
            flexWrap: 'wrap', background: 'var(--fn-danger-pale)', borderBottom: '1px solid var(--fn-danger-line)',
            color: 'var(--fn-danger-deep)', fontSize: 13.5, fontWeight: 700, padding: '10px 16px',
          }}>
            <span>⏸️ Tous tes envois sont en pause — aucun e-mail ni SMS ne part vers tes contacts.</span>
            <NavLink to="/settings/envois" style={{
              background: 'var(--fn-danger)', color: '#fff', textDecoration: 'none',
              borderRadius: 999, padding: '5px 14px', fontWeight: 800, fontSize: 12.5, whiteSpace: 'nowrap',
            }}>Reprendre les envois →</NavLink>
          </div>
        )}
        {/* Mobile header */}
        <header className="mobile-header">
          <button
            className={`mobile-menu-btn${sidebarOpen ? ' is-open' : ''}`}
            onClick={() => setSidebarOpen(o => !o)}
            aria-label="Menu"
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
          <span className="mobile-brand">appee</span>
          <button className="logout-btn logout-btn-mobile" onClick={handleLogout} title="Se déconnecter">
            <LogoutIcon />
          </button>
        </header>

        {/* Auto-send disabled banner */}
        {!autoSendEnabled && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 10,
            background: '#FFF7ED', borderBottom: '1px solid #FED7AA',
            padding: '9px 20px', fontSize: 13, color: '#92400E', fontWeight: 500,
          }}>
            <span style={{ fontSize: 16 }}>⏸️</span>
            <span>
              <strong>Envoi automatique désactivé</strong> — les e-mails d'anniversaire ne sont pas envoyés automatiquement.
            </span>
            <NavLink to="/settings/reports" style={{ marginLeft: 'auto', fontWeight: 700, color: '#D97706', textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0 }}>
              Réactiver →
            </NavLink>
          </div>
        )}

        <AiDisabledBanner />

        <div className="page-content">
          <GenieCoach />
          {children}
        </div>
      </main>

      {/* ── Toast notifications ── */}
      <div className="notifications">
        {notifications.map(n => (
          <div key={n.id} className={`notification notification-${n.type}`}>
            {n.type === 'success' ? '✓' : '⚠'} {n.msg}
          </div>
        ))}
      </div>

      <ChatBubble />
    </div>
  );
}
